export default "__VITE_ASSET__BLZ2$oDE__"